import { tablesEnvironment } from './tables-environments';

export const coreEnvironment = {
  apiAdresse: '/api-adresse',
  apiGoogleDocs: 'https://docs.google.com',
  menuOpen: false,
  paging: {
    pageSize: 20,
    pageOptions: [20, 50, 100]
  },
  tables: tablesEnvironment
};
